import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const ReportsPageAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
